// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".step-block-accordion {\n  width: 100%;\n  border: none;\n  padding: 0px;\n  background-color: transparent;\n}", "",{"version":3,"sources":["webpack://src/views/policy-results/policy-results.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AACF","sourcesContent":[".step-block-accordion{\n  width: 100%;\n  border: none;\n  padding: 0px;\n  background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
